export function assertNonEmptyString(value, name) {
  if (!value || value === '' || value.trim() === '') {
    // eslint-disable-next-line no-console
    console.error(value);
    throw Error((name !== null && name !== void 0 ? name : 'the value') + " should not be empty \"/\"");
  }
}
//# sourceMappingURL=assertions.js.map